var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import Panel from "@/components/ui/panel/Panel.vue";
import ExportButton from "@/core/export/ExportButton.vue";
import PeriodSelector from "@/core/period/PeriodSelector.vue";
import { useReportDataset } from "@/core/report";
import DatasetFilter from "@/core/report/components/DatasetFilter.vue";
import DatasetTable from "@/core/report/components/DatasetTable.vue";
import PaginatorControls from "@/core/report/components/PaginatorControls.vue";
import PaginatorInfo from "@/core/report/components/PaginatorInfo.vue";
import PaginatorItemsPerPage from "@/core/report/components/PaginatorItemsPerPage.vue";
import SortContextMenu from "@/core/report/components/SortContextMenu.vue";
import TableZoomDropdown from "@/core/report/components/TableZoomDropdown.vue";
import { useTableZoom } from "@/core/report/use-table-zoom";
import { onMounted, ref, watch } from "vue";
import { fetchReportData } from "./api";
import { DEFAULT_SORTS, FIELDS, FILTER_FIELDS, PRESET_SORTS, SORTABLE_FIELDS, TABLE_FIELDS } from "./config";
import LoadingSpinner from "@/components/app/LoadingSpinner.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdvancedReportView',
    setup(__props, { expose: __expose }) {
        __expose();
        const { tableZoom } = useTableZoom();
        // Initialize with current month/year
        const selectedPeriod = ref(null);
        // Data state
        const isLoading = ref(false);
        const error = ref(null);
        const tableData = ref([]);
        // Initialize dataset
        const dataset = useReportDataset({
            tableData: () => tableData.value,
            tableFields: () => TABLE_FIELDS,
            filterFields: FILTER_FIELDS,
            sortableFields: SORTABLE_FIELDS,
            defaultSorts: DEFAULT_SORTS,
            itemsPerPage: 10,
        });
        // Load data
        const loadData = () => __awaiter(this, void 0, void 0, function* () {
            try {
                isLoading.value = true;
                error.value = null;
                const dataResponse = yield fetchReportData(selectedPeriod.value);
                tableData.value = dataResponse;
            }
            catch (err) {
                tableData.value = [];
                error.value = "Error al cargar los datos";
                console.error("Error loading report data:", err);
            }
            finally {
                isLoading.value = false;
            }
        });
        // Watch period changes and reload data
        watch(() => { var _a; return (_a = selectedPeriod.value) === null || _a === void 0 ? void 0 : _a.key; }, (newKey) => {
            if (newKey && selectedPeriod.value) {
                loadData();
            }
        });
        // Load data on mount
        onMounted(() => {
            if (selectedPeriod.value) {
                loadData();
            }
        });
        const __returned__ = { tableZoom, selectedPeriod, isLoading, error, tableData, dataset, loadData, Panel, ExportButton, PeriodSelector, DatasetFilter, DatasetTable, PaginatorControls, PaginatorInfo, PaginatorItemsPerPage, SortContextMenu, TableZoomDropdown, get FIELDS() { return FIELDS; }, get PRESET_SORTS() { return PRESET_SORTS; }, get TABLE_FIELDS() { return TABLE_FIELDS; }, LoadingSpinner };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
